import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';

import MemberProfileRegisteredEvents from './MemberProfileRegisteredEvents';
import MemberProfileListedProperties from './MemberProfileListedProperties';
import MemberProfileCurrentInterests from './MemberProfileCurrentInterests';
import MemberProfileSiteCriteria from './MemberProfileSiteCriteria';
import Tabs from '@molecules/Tabs';
import LoadingArea from '@molecules/LoadingArea';
import { BodyLarge, ButtonLink } from '@styled';
import useAuthorized from '@hooks/useAuthorized';

const MemberRecentActivityTabs = ({ graphID }) => {
    const history = useHistory();
    const location = useLocation();
    const [defaultActiveTab, setDefaultActiveTab] = useState();
    const { isMemberActive } = useAuthorized();

    useEffect(() => {
        if (location.hash) {
            setDefaultActiveTab(location.hash.substring(1));
        } else {
            setDefaultActiveTab('events-registered');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTabChange = tabKey => {
        history.replace({ hash: `#${tabKey}`, state: { graphID } });
    };

    if (!defaultActiveTab) return <LoadingArea />;

    return (
        <Tabs defaultActiveTab={defaultActiveTab} onTabChange={handleTabChange}>
            <div tabKey="events-registered" title="Event Registrations">
                <MemberProfileRegisteredEvents type="events-registered" graphID={graphID} />
            </div>

            <div tabKey="current-interests" title="Current Interests">
                <MemberProfileCurrentInterests type="current-interests" graphID={graphID} />
            </div>

            <div tabKey="listed-properties" title="Listed Properties">
                {!isMemberActive && (
                    <div>
                        <BodyLarge className="mb-1rem">
                            You must be an active member to see Listed Properties.
                        </BodyLarge>

                        <div className="d-flex">
                            <ButtonLink
                                href="/membership/start"
                                onClick={e => {
                                    e.preventDefault();
                                    window.location.href = '/membership/start';
                                }}
                            >
                                Join Now
                            </ButtonLink>
                        </div>
                    </div>
                )}

                {isMemberActive && <MemberProfileListedProperties type="listed-properties" graphID={graphID} />}
            </div>

            <div tabKey="site-criteria" title="Site Criteria">
                {!isMemberActive && (
                    <div>
                        <BodyLarge className="mb-1rem">You must be an active member to see Site Criteria.</BodyLarge>

                        <div className="d-flex">
                            <ButtonLink
                                href="/membership/start"
                                onClick={e => {
                                    e.preventDefault();
                                    history.push('/membership/start');
                                }}
                            >
                                Join Now
                            </ButtonLink>
                        </div>
                    </div>
                )}

                {isMemberActive && <MemberProfileSiteCriteria type="site-criteria" graphID={graphID} />}
            </div>
        </Tabs>
    );
};

MemberRecentActivityTabs.propTypes = {
    graphID: PropTypes.string,
};

export default MemberRecentActivityTabs;
